var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUnLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 302,
    viewBox: "0 0 302 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 31,
    width: 240,
    height: 218
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.002 31.7109C119.375 31.7459 89.0529 44.3252 66.6891 66.6887C44.3253 89.0522 31.7459 119.373 31.7109 151C31.7141 170.008 36.2618 188.739 44.9748 205.631C53.6879 222.524 66.3136 237.088 81.7992 248.11V221.754C81.7992 216.468 82.8402 211.234 84.863 206.351C86.8857 201.468 89.8505 197.031 93.588 193.293C97.3255 189.556 101.763 186.591 106.646 184.568C111.529 182.546 116.763 181.505 122.049 181.505H179.955C190.63 181.505 200.868 185.745 208.416 193.293C215.964 200.841 220.205 211.079 220.205 221.754V248.11C235.69 237.089 248.316 222.524 257.029 205.632C265.742 188.739 270.29 170.008 270.293 151C270.257 119.374 257.677 89.0531 235.313 66.6899C212.95 44.3266 182.629 31.747 151.002 31.7109ZM151.002 156.751C140.052 156.738 129.553 152.383 121.81 144.64C114.067 136.897 109.712 126.399 109.699 115.449C109.713 104.499 114.069 94.0024 121.812 86.2604C129.555 78.5184 140.052 74.1636 151.002 74.1511C161.951 74.1636 172.449 78.5184 180.192 86.2604C187.935 94.0024 192.291 104.499 192.304 115.449C192.292 126.399 187.937 136.897 180.193 144.64C172.45 152.383 161.952 156.738 151.002 156.751Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.123 31.123H270.886V248.69H31.123V31.123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 303,
    height: 302
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.002 0C110.954 0 72.5459 15.9089 44.2275 44.2269C15.9091 72.5448 0 110.952 0 151C0 191.048 15.9091 229.455 44.2275 257.773C72.5459 286.091 110.954 302 151.002 302C191.05 302 229.458 286.091 257.777 257.773C286.095 229.455 302.004 191.048 302.004 151C302.004 110.952 286.095 72.5448 257.777 44.2269C229.458 15.9089 191.05 0 151.002 0ZM151.002 285.605C115.313 285.565 81.0961 271.371 55.8577 246.137C30.6194 220.903 16.4198 186.689 16.3735 151C16.4141 115.307 30.6112 81.088 55.8502 55.8494C81.0891 30.6108 115.309 16.4139 151.002 16.3733C186.692 16.4196 220.906 30.619 246.14 55.857C271.375 81.095 285.569 115.311 285.609 151C285.563 186.685 271.367 220.896 246.133 246.129C220.899 271.363 186.688 285.559 151.002 285.605Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.587891 -0.587891H302.593V302.589H-0.587891V-0.587891Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnLogin);
export default __webpack_public_path__ + "static/media/profileUnLogin.ead1963bc45d134903a5dc2abcbce093.svg";
export { ForwardRef as ReactComponent };